import { render, staticRenderFns } from "./YljDetail.vue?vue&type=template&id=cc5b48c4&scoped=true&"
import script from "./YljDetail.vue?vue&type=script&lang=js&"
export * from "./YljDetail.vue?vue&type=script&lang=js&"
import style0 from "./YljDetail.vue?vue&type=style&index=0&id=cc5b48c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5b48c4",
  null
  
)

export default component.exports